'use client';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';

const services = [
{
  id: 'service_consignment',
  icon: 'public/assets/images/ChatGPT_Image_Feb_7_2026_02_48_47_AM-1770428942096.png',
  title: 'Consignment Services',
  description: 'Complete consignment management from pickup to final delivery with real-time visibility.',
  features: ['Multi-Stop Routing', 'Inventory Tracking', 'Proof of Delivery'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1031f59ea-1764660301435.png",
  alt: 'Logistics warehouse with organized consignment inventory and shipping materials'
},
{
  id: 'service_freight',
  icon: 'GlobeAltIcon',
  title: 'International Freight',
  description: 'Air, ocean, and ground freight solutions for global shipping with customs support.',
  features: ['Air & Ocean Freight', 'Customs Clearance', 'Door-to-Door'],
  image: "https://images.unsplash.com/photo-1631451378668-25c49d8c91be",
  alt: 'International cargo ship loaded with containers at port for global freight shipping'
},
{
  id: 'service_warehouse',
  icon: 'BuildingStorefrontIcon',
  title: 'Warehousing & Distribution',
  description: 'Secure storage facilities with inventory management and order fulfillment services.',
  features: ['Climate Control', 'Security 24/7', 'Order Fulfillment'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15f63d3ca-1767958639289.png",
  alt: 'Modern warehouse facility with organized storage racks and distribution systems'
},
{
  id: 'service_tracking',
  icon: 'MapPinIcon',
  title: 'Real-Time Tracking',
  description: 'Track every stop point of your shipment with detailed location updates and ETAs.',
  features: ['Live GPS Tracking', 'Stop-by-Stop Updates', 'Delivery Alerts'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19909a5f4-1767607584266.png",
  alt: 'Digital tracking interface showing real-time shipment location and route map'
}];



export default function ServicesSection() {
  return (
    <section className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            Our Logistics Services
          </h2>
          <p className="text-lg text-muted-foreground">
            End-to-end consignment and logistics solutions for businesses worldwide
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {services.map((service) =>
          <div
            key={service.id}
            className="group bg-card rounded-xl overflow-hidden border border-border hover:border-primary/50 hover:shadow-card-hover transition-all duration-300 hover:scale-105">
            
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden">
                <AppImage
                src={service.image}
                alt={service.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                    <Icon name={service.icon as any} size={24} className="text-primary" />
                  </div>
                </div>
              </div>

              {/* Service Content */}
              <div className="p-6">
                <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-4">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, index) =>
                <li key={index} className="flex items-center gap-2 text-sm text-foreground">
                      <Icon name="CheckIcon" size={16} className="text-success" />
                      <span>{feature}</span>
                    </li>
                )}
                </ul>
              </div>
            </div>
          )}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <Link
            href="/products"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-all hover:scale-105 shadow-lg">
            
            <Icon name="CubeIcon" size={20} />
            <span>View All Services</span>
            <Icon name="ArrowRightIcon" size={20} />
          </Link>
        </div>
      </div>
    </section>);

}